export function Footer() {
  return (
    <footer className="border-t bg-card py-4 gap-2">
      <div className="text-xs text-muted-foreground text-center">
        <p>
          This tool uses secure authentication with your Cloudflare account.
          <br />
          Your API token and Account ID are never stored in your browser.
        </p>
      </div>
      <div className="container mx-auto text-sm content-center flex justify-center items-center text-center text-slate-300">
        &copy; {new Date().getFullYear()} Cloudflare KV Viewer
      </div>
    </footer>
  );
}
